/**
 * Storage service
 *
 */
app.factory('StorageService', [function() {
    return {

        /**
         * Get the stored tickets
         */
        get_tickets: function() {
            try {
                return JSON.parse(localStorage.getItem('tkt_tickets') || '[]');
	    } catch( e) {
              console.error('tkt:error Could not access local storage');
              return [];
            }
        },

        /**
         * Store a new ticket
         *
         * @param ticket
         */
        store_ticket: function(ticket) {
            var tickets = this.get_tickets().filter(function (stored_ticket) {
                if (stored_ticket._id === ticket._id)
                    return false;

                return true;
            });

            tickets.push(ticket);

            try {
                localStorage.setItem('tkt_tickets', JSON.stringify(tickets));
	    } catch( e) {
              console.error('tkt:error Could not access local storage');
              return false;
            }
        },

        /**
         * Remove a ticket
         *
         * @param ticket
         */
        remove_ticket: function(ticket) {
            var tickets = this.get_tickets().filter(function (stored_ticket) {
                if (stored_ticket._id === ticket._id)
                    return false;

                return true;
            });

            try {
                localStorage.setItem('tkt_tickets', JSON.stringify(tickets || []));
	    } catch( e) {
              console.error('tkt:error Could not access local storage');
              return false;
            }
        }
    };
}]);
